import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  PODisclaimerLabel,
  type PODisclaimerLabelConstructor,
} from './PODisclaimerLabel'

export const PODisclaimerLabelConstructorFactory =
  Factory.Sync.makeFactory<PODisclaimerLabelConstructor>({
    id: Factory.each(() => faker.random.number()),
    description: Factory.each(() => faker.lorem.words()),
    text: Factory.each(() => faker.lorem.sentence()),
  })

export const PODisclaimerLabelFactory = EntityFactory(
  PODisclaimerLabel,
  PODisclaimerLabelConstructorFactory
)
